import { useTranslation } from '@pancakeswap/localization'
import { Box, useModal, UserMenu as UIKitUserMenu, UserMenuVariant } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useCopyToClipboard } from 'react-use'
import ConnectWalletButton from 'components/ConnectWalletButton'
import Trans from 'components/Trans'
import { useActiveChainId } from 'hooks/useActiveChainId'
import useAuth from 'hooks/useAuth'
import { useEffect, useState } from 'react'
import { useProfile } from 'state/profile/hooks'
import { usePendingTransactions } from 'state/transactions/hooks'
import { useAccount } from 'wagmi'
import { helperToast } from 'utils/helperToast'
import WalletModal, { WalletView } from './WalletModal'
import { LogoCopy, ExternalLink, Disconnect } from '../../../../packages/uikit/src/components/Svg'

const WrapperMenu = styled.div`
  .menu-item {
    display: flex;
  }
`

const UserMenu = () => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const { chainId, isWrongNetwork } = useActiveChainId()
  const { logout } = useAuth()
  const { hasPendingTransactions, pendingNumber } = usePendingTransactions()
  const { isInitialized, isLoading, profile } = useProfile()
  // const [onPresentWalletModal] = useModal(<WalletModal initialView={WalletView.WALLET_INFO} />)
  // const [onPresentTransactionModal] = useModal(<WalletModal initialView={WalletView.TRANSACTIONS} />)
  // const [onPresentWrongNetworkModal] = useModal(<WalletModal initialView={WalletView.WRONG_NETWORK} />)
  const hasProfile = isInitialized && !!profile
  const avatarSrc = profile?.nft?.image?.thumbnail
  const [userMenuText, setUserMenuText] = useState<string>('')
  const [userMenuVariable, setUserMenuVariable] = useState<UserMenuVariant>('default')

  useEffect(() => {
    if (hasPendingTransactions) {
      setUserMenuText(t('%num% Pending', { num: pendingNumber }))
      setUserMenuVariable('pending')
    } else {
      setUserMenuText('')
      setUserMenuVariable('default')
    }
  }, [hasPendingTransactions, pendingNumber, t])

  // const onClickWalletMenu = (): void => {
  //   if (isWrongNetwork) {
  //     onPresentWrongNetworkModal()
  //   } else {
  //     onPresentWalletModal()
  //   }
  // }

  const [, copyToClipboard] = useCopyToClipboard()

  const UserMenuItems = () => {
    return (
      <WrapperMenu>
        <div
          className="menu-item"
          onClick={() => {
            copyToClipboard(account)
            helperToast.success('Address copied to your clipboard')
          }}
        >
          <LogoCopy />
          <p>Copy Address</p>
        </div>
        <a
          href={`https://optimistic.etherscan.io/address/${account}`}
          target="_blank"
          rel="noopener noreferrer"
          className="menu-item"
        >
          <ExternalLink />
          <p>View in Explorer</p>
        </a>
        <div className="menu-item" onClick={logout}>
          <Disconnect />
          <p>Disconnect</p>
        </div>
      </WrapperMenu>
    )
  }

  if (account) {
    return (
      <UIKitUserMenu account={account} avatarSrc={avatarSrc} text={userMenuText} variant={userMenuVariable}>
        {({ isOpen }) => (isOpen ? <UserMenuItems /> : null)}
      </UIKitUserMenu>
    )
  }

  if (isWrongNetwork) {
    return (
      <UIKitUserMenu text={t('Network')} variant="danger">
        {({ isOpen }) => (isOpen ? <UserMenuItems /> : null)}
      </UIKitUserMenu>
    )
  }

  return (
    <ConnectWalletButton scale="md">
      <Box display={['none', , , 'block']}>
        <Trans>Connect Wallet</Trans>
      </Box>
      <Box display={['block', , , 'none']}>
        <Trans>Connect</Trans>
      </Box>
    </ConnectWalletButton>
  )
}

export default UserMenu
